<script setup lang="ts">
import { computed } from "vue";

const props = defineProps({
    content: Object,
});

const title = computed(() => props.content?.title);
const slug = computed(() => props.content?.recipeCategory?.slug);
</script>

<template>
    <RecommendByCategory v-if="title && slug"
                         :category-slug="slug"
                         :page-size="4"
                         :title="title"
                         title-center
    />
</template>